import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Award, ShieldCheck, ShieldX, Search, Loader2 } from "lucide-react";

export default function VerifyCertificate() {
  const { certId } = useParams();
  const nav = useNavigate();
  const [q, setQ] = useState(certId || "");
  const [state, setState] = useState({ status: "idle" });
  useEffect(() => {
    if (!certId) return;
    setState({ status: "loading" });
    api.get(`/learn/certificate/verify/${certId.trim().toUpperCase()}`).then((r) => setState({ status: "valid", data: r.data })).catch(() => setState({ status: "invalid" }));
  }, [certId]);
  const submit = (e) => { e.preventDefault(); const id = q.trim().toUpperCase(); if (id) nav(`/verify/${id}`); };
  const fmt = (d) => d ? new Date(d).toLocaleDateString([], { month: "long", day: "numeric", year: "numeric" }) : "";
  return (
    <main className="max-w-2xl mx-auto px-4 sm:px-8 py-16" data-testid="verify-page">
      <p className="font-mono text-xs tracking-widest uppercase text-cyan-400">// Certificate verification</p>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-1">Check a Road Ready certificate</h1>
      <p className="text-slate-400 text-sm mt-2">Employers and fleet partners: enter the certificate ID printed at the bottom of a driver's certificate to confirm it was issued by MY VELOCITY.</p>
      <form onSubmit={submit} className="mt-6 flex gap-2" data-testid="verify-form">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="e.g. E64D15FA8ED9" className="font-mono uppercase bg-[#131722] border-slate-700" data-testid="verify-input" />
        <Button type="submit" disabled={!q.trim()} className="bg-cyan-400 text-slate-950 hover:bg-cyan-300 font-semibold" data-testid="verify-submit"><Search className="w-4 h-4 mr-1.5" />Verify</Button>
      </form>
      {state.status === "loading" && <div className="mt-8 flex items-center gap-2 text-slate-400"><Loader2 className="w-4 h-4 animate-spin" />Checking…</div>}
      {state.status === "valid" && (
        <section className="mt-8 p-6 rounded-2xl bg-amber-400/10 border border-amber-400/40 flex gap-4 items-start" data-testid="verify-valid">
          <div className="w-14 h-14 rounded-full bg-amber-400 text-slate-950 flex items-center justify-center shrink-0 shadow-[0_0_30px_-5px_rgba(251,191,36,.8)]"><Award className="w-7 h-7" /></div>
          <div className="min-w-0">
            <p className="flex items-center gap-1.5 text-emerald-300 text-sm font-mono"><ShieldCheck className="w-4 h-4" />Valid certificate</p>
            <h2 className="font-display text-2xl font-bold mt-1" data-testid="verify-name">{state.data.name || "Velocity driver"}</h2>
            <p className="text-slate-300 text-sm mt-1">Road Ready · completed every chapter of Raq's MY VELOCITY driver manual</p>
            <p className="text-slate-500 text-xs font-mono mt-3">Issued {fmt(state.data.issued_at)} · ID {state.data.cert_id}</p>
          </div>
        </section>
      )}
      {state.status === "invalid" && (
        <section className="mt-8 p-6 rounded-2xl bg-rose-500/10 border border-rose-500/40 flex gap-4 items-center" data-testid="verify-invalid">
          <ShieldX className="w-8 h-8 text-rose-300 shrink-0" />
          <div><h2 className="font-display text-xl font-bold">No certificate found</h2><p className="text-slate-400 text-sm mt-1">Check the ID for typos. Certificates are 12 characters, letters and numbers.</p></div>
        </section>
      )}
    </main>
  );
}
